declare namespace $ {

	type $mol_button_minor__title_bog_blitz_lobby_reactions_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_lobby_reactions_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['react_heart'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_reactions_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['count_heart_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_lobby_reactions_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_blitz_lobby_reactions_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_lobby_reactions_6 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['react_smile'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_reactions_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['count_smile_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_lobby_reactions_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_blitz_lobby_reactions_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_lobby_reactions_10 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['react_fire'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_reactions_11 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['count_fire_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_lobby_reactions_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_blitz_lobby_reactions_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_lobby_reactions_14 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['react_clap'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_reactions_15 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['count_clap_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_lobby_reactions_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_blitz_lobby_reactions_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_blitz_lobby_reactions_18 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['react_poop'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_reactions_19 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_reactions['count_poop_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_blitz_lobby_reactions_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_blitz_lobby_reactions extends $mol_view {
		Spacer( ): $mol_view
		react_heart( next?: any ): any
		Btn_heart( ): $mol_button_minor
		count_heart_text( ): string
		Count_heart( ): $mol_paragraph
		Group_heart( ): $mol_view
		react_smile( next?: any ): any
		Btn_smile( ): $mol_button_minor
		count_smile_text( ): string
		Count_smile( ): $mol_paragraph
		Group_smile( ): $mol_view
		react_fire( next?: any ): any
		Btn_fire( ): $mol_button_minor
		count_fire_text( ): string
		Count_fire( ): $mol_paragraph
		Group_fire( ): $mol_view
		react_clap( next?: any ): any
		Btn_clap( ): $mol_button_minor
		count_clap_text( ): string
		Count_clap( ): $mol_paragraph
		Group_clap( ): $mol_view
		react_poop( next?: any ): any
		Btn_poop( ): $mol_button_minor
		count_poop_text( ): string
		Count_poop( ): $mol_paragraph
		Group_poop( ): $mol_view
		my_answers( ): any
		players_dict( ): any
		is_host( ): boolean
		Fly( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=reactions.view.tree.d.ts.map